import { QuizType } from '@repo/types/enums/quizType';
import { infer as Infer, z } from 'zod';

export const quizPublicSchema = z.object({
  id: z.string(),
  name: z.string(),
  desc: z.string().nullable(),
  type: z.enum(QuizType),
  time: z.number().nullable(),
  maxAttempts: z.number(),
  deadline: z.string().nullable(),
  available: z.string().nullable(),
  points: z.number(),
  updatedAt: z.string(),
  createdAt: z.string(),
});

export type QuizPublicSchema = Infer<typeof quizPublicSchema>;

export const quizPublicToId = z.codec(quizPublicSchema, z.string().uuid(), {
  decode: (quiz) => quiz.id,
  encode: () => {
    throw new Error('Cannot encode an id back to a QuizPublic');
  },
});
